// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"ProfileRating_ratingContainer__36Xy3","success":"ProfileRating_success__ylJtd","background":"ProfileRating_background__GQZlB"};